"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _urlSearchParams = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/url-search-params"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));
var _react = _interopRequireWildcard(require("react"));
var _universalCookie = _interopRequireDefault(require("universal-cookie"));
var _nanoid = _interopRequireDefault(require("nanoid"));
var _boolean2 = require("boolean");
function _interopRequireWildcard(e, t) { if ("function" == typeof _WeakMap) var r = new _WeakMap(), n = new _WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = _Object$defineProperty) && _Object$getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var _default = exports["default"] = function _default(debugName, cookieMaxAge) {
  return function (WrappedComponent) {
    var Component = function Component(props) {
      var _useState = (0, _react.useState)(),
        _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
        debugSessionId = _useState2[0],
        setDebugSessionId = _useState2[1];
      (0, _react.useEffect)(function () {
        var cookies = new _universalCookie["default"]();
        var query = new _urlSearchParams["default"](window.location.search);
        var debugParam = query.get(debugName);

        // if debug cookie exists, enable debug mode
        if (cookies.get(debugName)) {
          // even if cookie exists, if the query string is present and set to
          // a falsy value, let's remove the cookie and exit the debug session
          if (debugParam && !(0, _boolean2["boolean"])(debugParam)) {
            setDebugSessionId(null);
            cookies.remove(debugName);
          } else {
            setDebugSessionId(cookies.get(debugName, {
              doNotParse: true
            }));
          }
        } else if ((0, _boolean2["boolean"])(debugParam)) {
          // no cookie exists, check for query string
          // if query string exists, enable debug mode and save debug cookie
          var sessionId = (0, _nanoid["default"])();
          setDebugSessionId(sessionId);
          cookies.set(debugName, sessionId, {
            maxAge: cookieMaxAge
          });
        }
      }, []);
      return /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, props, {
        debugSessionId: debugSessionId
      }));
    };
    Component.displayName = WrappedComponent.displayName || WrappedComponent.name || 'withDebugMode';
    (0, _hoistNonReactStatics["default"])(Component, WrappedComponent);
    return Component;
  };
};